import { Box } from "@mui/material";
import { Alert, Typography } from "@platform/design-system";

export const DataQualityTab = (): React.JSX.Element => (
  <Box display="flex" flexDirection="column" gap={2}>
    <Typography variant="header-medium" component="h2">
      Data quality
    </Typography>
    <Alert severity="info">This section is under construction.</Alert>
  </Box>
);
